import { ScrollArea } from '@/src/components/ui/scroll-area';

interface Props {
  height?: number;
  title?: string;
  subTitle?: string;
  contents?: string;
  titlePrefix?: string;
  contentMinHeight?: number;
}

export default function ContentsPreview({
  height = 817,
  title,
  subTitle,
  contents,
  titlePrefix,
  contentMinHeight = 500,
}: Props) {
  return (
    <article
      className="border-gray10 flex flex-1 flex-col overflow-hidden rounded-lg border px-[8px]"
      style={{ height: `${height}px` }}
    >
      <header className="sticky top-0 z-10 flex flex-col gap-2 border-b border-gray2 bg-white px-4 py-6">
        <h3 className="flex items-start gap-1 font-pretendardSemiBold text-b16sb text-gray9">
          {titlePrefix && (
            <span className="flex-shrink-0 text-b16sb">[{titlePrefix}]</span>
          )}
          {title || ''}
        </h3>
        {subTitle && (
          <p className="flex items-start gap-1 text-b14r text-gray9">
            {subTitle}
          </p>
        )}
      </header>
      <ScrollArea className="w-full flex-1 overflow-auto">
        <div
          className="ck-content ck-content-section px-4 py-6"
          style={{ minHeight: `${contentMinHeight}px` }}
        >
          <div
            className="[&>.magazine-header]:hidden"
            style={{
              all: 'unset',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
            dangerouslySetInnerHTML={{
              __html: contents || '',
            }}
          />
        </div>
      </ScrollArea>
    </article>
  );
}
